export class FetchError extends Error {
  readonly isFetchError = true;

  constructor(
    public readonly request: Request,
    public readonly response: Response,
    message: string,
  ) {
    super(message);
    this.name = 'FetchError';
  }
}

export const checkFetchError = (err: unknown): err is FetchError => err instanceof FetchError && err.isFetchError;
